module.exports = __webpack_public_path__ + "img/ic-tpbank.6c18a4bc.svg";